import type { FaireProductEntity } from "../../entity_types/product";

export const p_wey62vh3mu: FaireProductEntity = {
  token: "p_wey62vh3mu",
  type: "product",
  name: "The Boobies N Beer Glass",
  brandToken: "b_6qajwqdzz3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b14912793b061861be4df11f2fd924283bf74fecee1ee100e9f48a84898d81f2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8356d699389da3918c26493445e3a1e1738d1d3644df98beb9bfed221400903a.jpeg",
    "https://cdn.faire.com/fastly/57fbd3d338dd328c3081b0da97b7590b92435ffb8e0b037aeff7627b29b1e695.jpeg",
  ],
  priceDollars: 17.32,
  description:
    "You certainly can have your cake and eat it too...our best-selling beer glass combines the awesome-sauce of a tall pour with boobs. That's right, Boobies n' Beer. Pinch us, because life cannot simply be this good.",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:48.454Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
